import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { AvatarSprite } from "../features/drop/AvatarSprite";
import { avatarsOf, colourOf, playingEmote, shortId, slotsOf } from "../features/drop/stage";
import { useCanvasState } from "../lib/useCanvasState";
import { useTransparentCanvas } from "../lib/useTransparentCanvas";

/** The agent canvas: transparent, and stacked over a capture of the same screen. */
export const Route = createFileRoute("/drop/display/$stageMount")({
  component: DisplayCanvas,
});

const SPRITE_HEIGHT = 0.14;

function DisplayCanvas() {
  const { stageMount } = Route.useParams();
  useTransparentCanvas();
  const stage = useCanvasState(stageMount);

  const bodies = avatarsOf(stage.state);
  const slots = slotsOf(stage.state);

  // Never on the canvas, because this one is on air. The console is where a browser source says
  // why it is blank, and a blank broadcast with no explanation anywhere is the worse failure.
  useEffect(() => {
    if (stage.error !== null) console.warn(`[canvas] cannot read this stage: ${stage.error}`);
  }, [stage.error]);

  return (
    <main style={{ position: "fixed", inset: 0, background: "transparent", overflow: "hidden" }}>
      {bodies.map((body) => (
        <div
          key={body.id}
          style={{
            position: "absolute",
            left: `${body.x * 100}%`,
            top: `${body.y * 100}%`,
            transform: "translate(-50%, -100%)",
            transition: "left 140ms linear, top 140ms linear",
          }}
        >
          <AvatarSprite
            facing={body.facing}
            colour={colourOf(body.id)}
            emote={playingEmote(body, slots)}
            height={window.innerHeight * SPRITE_HEIGHT}
            label={`${shortId(body.id)} on the stage`}
          />
        </div>
      ))}
    </main>
  );
}
